import axios from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { AdGroupDataScopeDto, ModuleV2Dto } from '../../../../codegen/Swagger';
import { getApi } from '../../../../config/SwaggerApi';
import { configQueryReactSimpleRequestSecurity } from '../../config';
const fetchAdGroupsByModuleId = (moduleId: ModuleV2Dto) => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const promise = getApi()
        .security.securityGetDataScopesByModuleIdGet(
            { ModuleId: moduleId.moduleId },
            {
                cancelToken: source.token,
            },
        )
        .then((response) => response.data);
    (promise as any).cancel = () => {
        source.cancel('Query was cancelled by React Query');
    };
    return promise;
};

const useAdGroupsDataScopesByModuleId = (module: ModuleV2Dto, options?: UseQueryOptions) => {
    const adGroupsQuery = useQuery<AdGroupDataScopeDto[], Error>(
        ['adgroups-module-', module?.moduleId],
        () => fetchAdGroupsByModuleId(module),
        {
            ...configQueryReactSimpleRequestSecurity,
            enabled: module != null,
        },
    );
    const transformedData = adGroupsQuery.data?.map((o: any) => {
        return { id: o['parameter'].id, ...o };
    });

    const allParameters = adGroupsQuery.data?.map((o: any) => o['parameter']);

    return { ...adGroupsQuery, allParameters, data: transformedData };
};

export default useAdGroupsDataScopesByModuleId;
